export enum OttopilotGeographicNodesWorkspaceCapabilityAccessOperation {
    create = "848dbe4f-3971-4d44-966a-795da307c640",
    read = "cba276a1-c935-47de-bb61-909a7706e7a6",
    update = "bb37a82d-d73b-4836-963a-f38ad6a8ea02",
    delete = "0c02219b-c096-4944-8660-cff91c4b0151",
}
